import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Header from "../Header";
import Footer from "../Footer";

Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
});

  const styles = StyleSheet.create({
    pagewapper: {
        position: "relative",
        height: "100%"
    },
    content: {
        display: "flex",
        width: "570px",
        alignItems: "left"
    },
      contenttitle: {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: "18px",
        lineHeight: "30px",
        color: "#426B88"
    },
    wapper: {
        width: "567px",
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "18px",
        color: "#245775"
      },
      mainContent: {
          flexGrow: 1,
          marginTop:"28px",
    },
    footer: {
        marginTop: 'auto',
    },
    table: {
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 2,
        alignItems: 'center',
    },
      tableHeader: {
        paddingVertical: 1,
        fontWeight: 400,
        border:'0px',
        backgroundColor: '#245775',
        fontWeight: 'bold',
        color: 'white',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
    headerCell:{color: 'white', fontWeight:400, paddingVertical:"5px"},
    cellQuestion: { width: '70%', fontSize: 10,color:"#394554", fontWeight:400},
    cellScore: { width: '7%', textAlign: 'center', fontSize: 10 },
    cell: {
        padding: "10px",
        textAlign: "left",
      },
      
      rowEven: {
        backgroundColor: "#F1F3F3",
      },
      rowOdd: {
        backgroundColor: "#FFF",
      },
      redRectangle: {
        width: 17,
        height: 17,
          backgroundColor: '#667F96',
        borderRadius:"1.34px",
    },
    grayRectangle: {
        width: 17,
        height: 17,
        backgroundColor: '#667F96',
        borderRadius: "1.34px",
    },
      
  });

  const truncateText = (text, limit) => {
    if (text.length <= limit) return text;
    return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
  };

  const getLastFilledIndex = (scores) => {
    for (let i = scores.length - 1; i >= 0; i--) {
      if (scores[i] === 1) return i;
    }
    return -1;
  };

  const renderRectangle = (score, index, scores) => {
    const lastFilledIndex = getLastFilledIndex(scores);
    return index <= lastFilledIndex ? <View style={styles.grayRectangle} /> : null;
  };

const StrategicPage = () => (
  <View style={styles.pagewapper}>
    <Header />
      <View style={styles.content}>
        <Text style={styles.contenttitle}>STRATEGIC LEADERSHIP IN FOCUS</Text>
        <View style={styles.wapper}>
          <Text>This chart isolates the items related to the participant’s self-ranking in relation to the items measuring Strategic Leadership. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.</Text>
        </View>         
      </View>
      <View style={styles.mainContent}>
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Strategic</Text>
            {[1, 2, 3, 4].map((num) => (
              <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]}>
                {num}
              </Text>
            ))}
          </View>

          {data.map((item, index) => (
            <View key={index} style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]}>
              <Text style={[styles.cell, styles.cellQuestion]}>{truncateText(item.question, 80)}</Text>
              {item.scores.map((score, idx) => (
                <View key={idx} style={[styles.cell, styles.cellScore]}>
                  {renderRectangle(score, idx, item.scores)}
                </View>
              ))}
            </View>
          ))}
      </View>
    <Footer/>
  </View>
);

export default StrategicPage;


const data = [
    {
      "quadrant": "STRATEGIC",
      "question": "When leading through conflict, I follow a specific process to work through it.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I am at my best when creating standardized processes that help others achieve their goals more easily.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I believe leading an organization requires a unified set of operating principles.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "My most important responsibility is the long-term effective stewardship of organizational assets.",
      "scores": [1, 1, 1, 1]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I believe effective strategy is primary.",
      "scores": [1, 1, 1, 0]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I believe the best way to achieve effectiveness is through good policies.",
      "scores": [1, 1, 1, 0]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I believe strategic thinking is the main contributor of success.",
      "scores": [1, 1, 1, 0]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I believe strategic thinking is the main contributor of success.",
      "scores": [1, 1, 0, 0]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I believe strategic thinking is the main contributor of success.",
      "scores": [1, 0, 0, 0]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I find great satisfaction in developing effective strategies for our organization.",
      "scores": [1, 0, 0, 0]
    },
    {
      "quadrant": "STRATEGIC",
      "question": "I find great satisfaction in developing effective strategies for our organization.",
      "scores": [1, 0, 0, 0]
    }
  ]
